import { render, staticRenderFns } from "./EndPage.vue?vue&type=template&id=0c7c7ad0&scoped=true&"
import script from "./EndPage.vue?vue&type=script&lang=js&"
export * from "./EndPage.vue?vue&type=script&lang=js&"
import style0 from "./EndPage.vue?vue&type=style&index=0&id=0c7c7ad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c7ad0",
  null
  
)

export default component.exports